import { useQuery } from '@apollo/client';
import { MultiSelect } from '@sixfold/common-ui';
import React from 'react';

import { apiEndpointUsageLogsEndpointsQuery } from '../../company/graphql';
import { ApiEndpointUsageLogsEndpointsQuery, ApiEndpointUsageLogsEndpointsQueryVariables } from '../../lib/graphql';

interface EndpointDropdownProps {
  value: string[];
  onChange: (value: string[]) => void;
  className?: string;
}

interface ReactSelectAdditionalProps {
  closeMenuOnSelect?: boolean;
}

export const EndpointDropdown: React.FunctionComponent<EndpointDropdownProps> = ({ value, onChange, className }) => {
  const { data } = useQuery<ApiEndpointUsageLogsEndpointsQuery, ApiEndpointUsageLogsEndpointsQueryVariables>(
    apiEndpointUsageLogsEndpointsQuery,
  );

  const endpoints = data?.apiEndpointUsageLogsEndpoints ?? [];
  const options = endpoints.map((endpoint) => ({
    label: endpoint.endpointName,
    value: endpoint.endpointId,
  }));

  const selectedValues = value.map((val) => {
    const option = options.find((opt) => opt.value === val);
    return option ?? { label: val, value: val };
  });

  const additionalProps: ReactSelectAdditionalProps = {
    closeMenuOnSelect: false,
  };

  return (
    <MultiSelect
      className={className}
      label="Endpoint"
      labelPosition="block"
      onChange={(selected) => {
        if (Array.isArray(selected)) {
          onChange(selected.map((s) => s.value));
        } else {
          onChange([]);
        }
      }}
      options={options}
      usePortal
      value={selectedValues}
      {...additionalProps}
    />
  );
};
